import { siteConfig } from "~/config/site"

export type InternalNavigationLink = {
  href: string
  labelKey: string
}

export type PriorityHubLink = {
  href: string
  label: string
}

// Crawlable internal links for the directory surfaces (also asserted by config/__tests__/links.test.ts).
export const directoryNavigationLinks = [
  { href: "/tools", labelKey: "navigation.tools" },
  { href: "/categories", labelKey: "navigation.categories" },
  { href: "/ai-crawler-checker", labelKey: "navigation.ai_crawler_checker" },
  { href: "/rss.xml", labelKey: "navigation.rss_feed" },
] satisfies InternalNavigationLink[]

// Directory browsing links, shared by header and footer.
export const browseNavigationLinks = [
  { href: "/ai-crawler-checker", labelKey: "navigation.ai_crawler_checker" },
  { href: "/categories", labelKey: "navigation.categories" },
  { href: "/tools", labelKey: "navigation.tools" },
] satisfies InternalNavigationLink[]

// "Guides" group: priority SEO hubs. Ordered alphabetically by display label.
export const priorityHubLinks = [
  { href: "/guides/ai-web-scraping", label: "AI Scraping" },
  { href: "/guides/no-code-web-scrapers", label: "No-Code" },
  { href: "/guides/open-source-web-scrapers", label: "Open Source" },
  { href: "/guides/scraping-api", label: "Scraping APIs" },
  { href: "/guides/sitemap-scrapers", label: "Sitemaps" },
] satisfies PriorityHubLink[]

// "Company" group: trust surfaces. Ordered alphabetically by display label.
export const companyNavigationLinks = [
  { href: "/about", labelKey: "navigation.about" },
  { href: `mailto:${siteConfig.email}`, labelKey: "navigation.contact_us" },
] satisfies InternalNavigationLink[]
